import { Link } from "react-router-dom";
import { Users, Radio, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useLang } from "@/context/AppContext";
import { useLiveEvent } from "@/context/RealtimeContext";
import { PageHead } from "@/pages/app/Dashboard";
import { useApi } from "@/lib/useApi";

export default function Communities() {
  const { t } = useLang();
  const { data: items, reload: load } = useApi("/communities", { initial: [] });
  useLiveEvent(["community_update"], load);
  const toggle = async (c) => {
    try { await api.post(`/communities/${c.id}/${c.joined ? "leave" : "join"}`); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div>
      <PageHead title={t("app_communities")} sub={t("communities_sub")} />
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {items.map((c, i) => (
          <article key={c.id} className="rise group flex flex-col rounded-md border border-white/[0.08] bg-[#111827] p-6 transition-colors duration-300 hover:border-emerald-400/30" style={{ animationDelay: `${i * 60}ms` }} data-testid={`community-card-${c.slug}`}>
            <div className="flex items-start justify-between">
              <p className="font-mono text-[10px] uppercase tracking-widest text-emerald-400">{c.sector}</p>
              {c.live_broadcasts > 0 && <span className="inline-flex items-center gap-1 rounded-full bg-rose-500/15 px-2 py-0.5 font-mono text-[10px] uppercase tracking-widest text-rose-300"><Radio className="pulse-node h-3 w-3" />{t("live_now")}</span>}
            </div>
            <h3 className="mt-3 font-display text-2xl font-bold text-white">{c.name}</h3>
            <p className="mt-2 flex-1 text-sm text-slate-400">{c.description}</p>
            <div className="mt-6 flex items-center justify-between">
              <span className="inline-flex items-center gap-1.5 font-mono text-xs text-slate-400" data-testid={`community-members-${c.slug}`}><Users className="h-3.5 w-3.5" />{c.members} {t("members")}</span>
              <div className="flex items-center gap-2">
                <button onClick={() => toggle(c)} data-testid={`community-join-btn-${c.slug}`}
                  className={`rounded-full border px-4 py-1.5 text-xs transition-colors ${c.joined ? "border-emerald-400/40 text-emerald-300 hover:border-rose-400/40 hover:text-rose-300" : "border-white/15 text-slate-200 hover:border-emerald-400"}`}>
                  {c.joined ? t("joined") : t("join")}
                </button>
                <Link to={`/app/communities/${c.id}`} data-testid={`community-open-${c.slug}`} className="grid h-8 w-8 place-items-center rounded-full bg-emerald-500 text-slate-950 transition-transform group-hover:translate-x-0.5"><ArrowRight className="h-4 w-4" /></Link>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
